
import {Getter} from "vuex-class";
import {Component, Vue} from 'vue-property-decorator'
import {getCompanyNoticeInfo, MessageDetailDto, readMessage} from "@/api/workbench"
import {backToBefore, downFileToSystemFile} from "@/utils/h5ToApp";
import AppendixName from "@/components/AppendixName/index.vue";

@Component({
  name: 'MessageDetail',
  components: {AppendixName}
})
export default class MessageDetail extends Vue {
  @Getter companyId!: string
  detailInfo: MessageDetailDto = null
  fromPage = '' // fromPage=='1'的时候，说明是原生跳转过来的，此时，返回按钮需要调用原生返回方法
  fileName = ''
  showEmpty = false

  created() {
    // this.detailInfo = JSON.parse(.param as string)
    let query = this.$route.query
    let noticeId = query.noticeId
    let msgId = query.msgId
    // 获取通知公告详情
    this.getCompanyNoticeInfo(noticeId, msgId)
    this.fromPage = this.$route.query.fromPage ? this.$route.query.fromPage as string : '0'
  }

  handleBack() {
    if (this.fromPage === '1') {
      backToBefore()
    } else {
      this.$router.back()
    }
  }

  destroyed() {
    this.$eventBus.$emit('onMessageDetailBack')
  }

  /**
   * @description: 获取通知公告详情
   * @param {*公告编号}noticeId
   * @param {*消息编号}msgId
   * @return {*}
   */
  getCompanyNoticeInfo(noticeId, msgId) {
    const params = {
      companyId: this.companyId,
      noticeId
    }
    getCompanyNoticeInfo(params).then((res) => {
      this.detailInfo = res.data
      this.fileName = this.detailInfo.attachmentUrl ? this.detailInfo.attachmentUrl.split('/').pop() : ''
      // 阅读消息公告
      this.readMessage(msgId)
    }).finally(() => {
          this.showEmpty = true
        }
    )
  }

  /**
   * @description: 阅读消息公告
   * @param {*消息编号}msgId
   * @return {*}
   */
  readMessage(msgId) {
    const params = {
      companyId: this.companyId,
      msgId
    }
    readMessage(params).then((res) => {
      console.log(res)
    })
  }

  /* 下载附件 */
  downloadFunc () {
    const data = {
      filePath: encodeURI(window.location.origin + this.$downloadUrl(this.detailInfo.attachmentUrl)), // 完整的url地址
      fileName: this.fileName
    }
    downFileToSystemFile(data)
  }
}
